/**
 * How a help-center markdown file becomes a URL.
 *
 * CommonJS on purpose: `scripts/check-content.js` runs this same module under
 * plain Node during `yarn build`, and the app imports it through webpack. One
 * implementation is what guarantees that the build check and the live site
 * agree on every slug.
 *
 * Files are named `NN-some-title.md`. The number is the article's position in
 * its category and nothing else -- it is deliberately left out of the slug.
 * Order & Payments has been renumbered three times (2020, Aug 2025, Mar 2026),
 * and while the number was part of the URL every renumber silently broke links:
 * the March rename of `05-membayar-lewat-ecommerce` to `12-` left a dead link
 * in `06-pembayaran-dengan-kartu-kredit.md`. With the number dropped, content
 * can be reordered freely and URLs stay put.
 */
const slugify = require("slugify");

const NUMBER_PREFIX = /^\d+-/;

/** "Order & Payments" -> "order-and-payments" */
function categorySlug(dirName) {
  return slugify(dirName).toLowerCase();
}

/** The slug the old `/category/:category/:question` routes used, number included. */
function legacySlug(fileName) {
  return slugify(fileName.replace(/\.md$/, "").toLowerCase());
}

/** "07-pembayaran-dengan-paypal.md" -> "pembayaran-dengan-paypal" */
function articleSlug(fileName) {
  return stripNumber(legacySlug(fileName));
}

/** Position within the category; files without a number sort last. */
function articleOrder(fileName) {
  const match = fileName.match(/^(\d+)-/);

  return match === null ? Number.MAX_SAFE_INTEGER : parseInt(match[1], 10);
}

/**
 * Also used on incoming legacy URLs: `/category/x/05-foo` resolves to `foo`
 * whatever number the file carries today. nginx applies the same rule for the
 * real 301 (`deployment/nginx.conf`).
 */
function stripNumber(slug) {
  return slug.replace(NUMBER_PREFIX, "");
}

module.exports = {
  categorySlug,
  legacySlug,
  articleSlug,
  articleOrder,
  stripNumber
};
